<template>
<path fill-rule="evenodd" d="M89.392 1.416C78.967 1.23 30.051-3.989 14.661 9.552-.683 23.052-4.518 50.424 9.363 60.868c13.881 10.444 59.596 7.865 71.868 8.086 8.013.144 51.717-1.512 67.336-11.41 10.97-6.95 14.2-21.071 5.518-36.438-8.783-18.895-57.636-19.562-64.693-19.69z" />
</template>

<script>
export default {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// components/_SVG/ShapeYearBtn4Tab.vue